import { 
    faEye, faEyeSlash, faIdCard, 
    faMoon, faStarAndCrescent, 
    faSun, faCheckCircle
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"



export const Beneficiary = ({imgUrl, name, name2}) => {
    return (
        <button className="btn btn-white shadow text-center mx-2"> 
            <p className="m-0"><img src={imgUrl} alt="head" className="rounded-circle" style={{ width : '50px', height: '50px'}} /></p>
            <p className="m-0 text-muted"> {name}</p>
            <p className="m-0 text-muted">{name2}</p>
        </button>
    )
}

export const Transactions = ({type, amount, date, transactionType}) => {
    return (
        <table className="w-100 border-bottom my-2">
            <tbody>
                <tr>
                    <td>{type}</td>
                    <td className="text-right"><span className="text-danger rounded p-1"><span style={{textDecoration: 'double line-through'}}>N</span>{amount}</span></td>
                </tr>
                <tr className="text-muted small">
                    <td>{transactionType}</td>
                    <td className="text-right">{date}</td>
                </tr>
            </tbody>
        </table>
    )
}

export const CoinComponent = ({price, coin}) =>  {
    return (
        <div className="col-3 bg-dark mx-2 my-2 my-md-3 p-2">
            <p className="small m-0">{price}</p>
            <p className="small text-muted m-0">{coin}</p>
        </div>
    )
}

export const ShowWalletAdress = () => {
    const [eye, setEye] = useState(faEye)
    const [wallet, setWallet] = useState('*'.repeat(sessionStorage.getItem('localId').length))
    const handleClick =() => {
        setEye(eye===faEye? faEyeSlash: faEye)
        setWallet(eye===faEye? sessionStorage.getItem('localId'): '*'.repeat(sessionStorage.getItem('localId').length))
    } 
    return <p className="small">
            <FontAwesomeIcon icon={faIdCard} className="mr-2" /> 
            {wallet} 
            <FontAwesomeIcon onClick={handleClick} icon={eye} style={{cursor: 'pointer'}} className="ml-4" /> 
        </p>
}

const getHour = () => {
    let today = new Date()
    let curHr = today.getHours()
    if (curHr < 12) {
        return {greet: 'Good Morning', icon: faMoon}
    } else if (curHr < 18) {
        return {greet: 'Good Afternoon', icon: faSun}
    } else {
        return {greet: 'Good Evening', icon: faStarAndCrescent}
    }
}

export const Greet = () => {
    return (
        <div className="col-md text-purple">
            <p className="h4">{getHour().greet} <FontAwesomeIcon icon={getHour().icon} className="text-warning align-middle" /> </p>
        </div>
    )
}

export const Status = ({title, description, status, Modal, id}) => {
    return (
       <>
             <button disabled={status==="success"?true: false} type="button" data-toggle="modal" data-target={`#${id}`} className={`bg-white btn btn-${status} text-left text-${status} mx-1`}> 
                <p className="m-0">{title} <FontAwesomeIcon icon={faCheckCircle} /></p>
                <p className="m-0 text-dark"> {description}</p>
            </button>
            {Modal}
       </>
    )
}